export const FirstSteps = 'First Steps';
export const Workspace = 'Workspace';
export const FillingEvent = 'Filling event';
